import { render, staticRenderFns } from "./location.vue?vue&type=template&id=72d3241e"
import script from "./location.vue?vue&type=script&lang=js"
export * from "./location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports